import { Tag } from "./Tag";

export class Div extends Tag {
}
